<div class="header-bar">
    <div class="header-left"></div>
    <div class="header-center">
      {{ newBeacon ? "Create New Beacon" : "Beacon" }}
    </div>
    <div *ngIf="newBeacon" class="header-right">
      <button mat-button color="fiord" (click)="cancel()">Cancel</button>
      <button
        mat-button
        color="lightGreen"
        (click)="saveNewBeacon()"
        [disabled]="saveDisabled"
      >
        Save New Beacon
      </button>
    </div>
    <div *ngIf="!newBeacon" class="header-right">
      <button mat-button color="warn" (click)="deleteBeacon()">
        Delete Beacon
      </button>
      <button
        mat-button
        color="lightGreen"
        (click)="saveBeaconUpdates()"
        [disabled]="saveDisabled"
      >
        Save Beacon Updates
      </button>
    </div>
</div>
<div class="beacon">
    <div class="containers">
        <div class="container beacon-details-container">
            <div class="container-header no-bottom-border">
                <div class="text">Beacon Details</div>
            </div>
            <div class="container-content">

                <div class="container-row">
                    <lhpe-input
                        class="input"
                        controlName="name"
                        placeholder="Beacon Name"
                        [formGroup]="beaconForm!"
                        [required]="true"
                        >
                    </lhpe-input>
                </div>

                <div class="container-row">
                    <lhpe-select
                        controlName="facilityFloor"
                        placeholder="Facility Floor"
                        [formGroup]="beaconForm!"
                        [required]="true"
                        [options]="floors"
                        optionValue="id"
                    >
                    </lhpe-select>
                </div>

                <div class="container-row">
                    <lhpe-textarea
                        class="input"
                        controlName="note"
                        placeholder="Notes about beacon. e.g. Color, Brand, Serial Number"
                        [formGroup]="beaconForm!"
                        [rows]="5"
                        [required]="false"
                    >
                    </lhpe-textarea>
                </div>

                <div class="container-row" [formGroup]="beaconForm!" >
                    <mat-slide-toggle formControlName="disabled">Disabled</mat-slide-toggle>
                </div>

            </div>
        </div>
        
        <div *ngIf="!newBeacon" class="beacon-regions-container" cdkDropListGroup>
          <div class="container">
              <div class="container-header no-bottom-border">
                  <div class="text">Available Regions - drag to assign</div>
              </div>
              <div class="container-content">
                  <div class="unassigned-regions">
                      <div class="region-name">
                          <div class="input-box">
                              <input 
                                  class="input"
                                  [(ngModel)]="regionSearchText"
                                  placeholder="Search"
                                  />
                          </div>
                      </div>
                      <div class="drop">
                          <mat-chip-list #chipList aria-label="Region selection" cdkDropList (cdkDropListDropped)="onDropBeaconRegion($event)" [cdkDropListData]="{list: 'unassigned', obj: unassignedRegions}">
                              <mat-chip *ngFor="let beacon of unassignedRegions | beaconRegionFilter: regionSearchText; let bi = index" cdkDrag [cdkDragData]="beacon">
                                  {{beacon.name}}
                              </mat-chip>
                          </mat-chip-list>
                      </div>
                  </div>
              </div>
          </div>
          <div class="container">
              <div class="container-header no-bottom-border">
                  <div class="text">Assigned Regions</div>
              </div>
              <div class="container-content">
                  <div class="assigned-regions">
                      <div class="drop">
                          <mat-chip-list #chipList aria-label="Region selection" cdkDropList (cdkDropListDropped)="onDropBeaconRegion($event)" [cdkDropListData]="{list: 'assigned'}">
                              <mat-chip selected *ngFor="let region of beacon!.beaconRegions!; let ri = index" cdkDrag [cdkDragData]="region" (removed)="onBeaconRegionRemove(region)">
                                  {{region.name}}
                                  <mat-icon matChipRemove>cancel</mat-icon>
                              </mat-chip>
                          </mat-chip-list>
                      </div>
                  </div>
              </div>
          </div>
        </div>

    </div>
</div>